import { INSTITUTIONS_MUTATION_ADD_ITEMS } from '@/store/modules/institutions/institutions.constant'

export default {
  [INSTITUTIONS_MUTATION_ADD_ITEMS]: (state, values) => {
    state.item.values.push(...values)
    state.item.page++
  }
}
